import { SupportedBrowsers } from './SupportedBrowsers';
import { getUserDeviceInfo } from './userAgentUtils';
const DEVICE_TYPE = {
  mobile: 'mobile',
  ios: 'ios',
  android: 'android',
  desktop: 'desktop'
};
export const getIsMobile = () => {
  return getUserDeviceInfo().any;
};
export const getUserDeviceType = () => {
  const deviceInfo = getUserDeviceInfo();

  if (deviceInfo.apple.device) {
    return DEVICE_TYPE.ios;
  }

  if (deviceInfo.android.device) {
    return DEVICE_TYPE.android;
  }

  if (deviceInfo.any) {
    return DEVICE_TYPE.mobile;
  }

  return DEVICE_TYPE.desktop;
};
export const isSafariOrIos = () => // safari is not a supported property on the Window type
// See: https://hubspot.slack.com/archives/C017FT4P2Q0/p1637193449092700
getUserDeviceType() === 'ios' || window.safari || navigator.vendor != null && navigator.vendor.match(/Apple Computer, Inc./) || navigator.userAgent.indexOf(SupportedBrowsers.Safari) > -1 && navigator.userAgent.indexOf(SupportedBrowsers.Chrome) < 0;
export const isReducedMotionEnabled = () => {
  const reducedMotionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const isEnabled = reducedMotionMediaQuery && reducedMotionMediaQuery.matches;
  return isEnabled;
};